<template>
  <section
    class="banner flex-one banner-h"
    :style="{ backgroundImage: `url(${bannerImg})` }"
  >
    <div class="banner-content flex-one jc-center py-4 px-2">
      <div class="banner-text">
        <h1>{{ TITLE.main }}</h1>
        <h1 class="fw-400 shadow-text" style="opacity: 0.9">
          {{ TITLE.sub }}
        </h1>
      </div>
    </div>
  </section>
</template>

<script>
import { reactive } from 'vue'

import { TITLE } from '@/config/constant.js'
import bannerImg from '@/assets/images/banner-home.png'

export default {
  setup() {
    const data = {
      bannerImg
    }
    return {
      ...reactive(data),
      TITLE
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  // height: 450px;
  // height: calc(100vw * 450px / 1920px);

  &-content {
    box-shadow: 0px 0px 15px rgb(0 0 0 / 8%);
    width: inherit;
    background-color: rgba($color: #fff, $alpha: 0.65);
  }
  &-text {
    h1 {
      text-align: center;
      font-weight: normal;
      line-height: unset;
      font-size: 2.8rem;
      margin: 0;
      // font-family: serif;
    }
  }
}

@media screen and (max-width: 500px) {
  .banner {
    max-height: 250px;
    &-text {
      h1 {
        font-size: 2.5rem;

        &:first-child {
          // font-size: 2rem;
        }
      }
    }
  }
}
</style>
